import "./home";
import "./engage";
import "./resources";

// alert("Akash")

// when scroll go to the top
$(window).on('beforeunload', function () {
    $(window).scrollTop(0); 
});


$(document).ready(function () {
    const $hamburger = $('.mobile-menu-icon .hamburger');
    const $closeButton = $('.mobile-menu-icon .close-btn');
    const $mobileMenu = $('.mobile-menu');
    const $body = $('body');
  
    $hamburger.on('click', function () {
        $mobileMenu.addClass('open'); 
        // $body.css('overflow', 'hidden');
        $("body").css("overflow", ""); 
        $hamburger.hide();
        $closeButton.show(); 
    });
  
    $closeButton.on('click', function () {
        $mobileMenu.removeClass('open'); 
        $("body").css("overflow", "hidden");
        $closeButton.hide(); 
        $hamburger.show();
    });
  });
  